import moment from 'moment';
import { isSDKInitialized } from './LiveLikeService';

export const fetchNotificationTransactions = async (sdkClient, profileId, durationInHours) => {
    if (!isSDKInitialized(sdkClient)) return [];

    try {
        const startTime = moment().format('YYYY-MM-DD HH:mm:ss');
        const endDate = moment().subtract(durationInHours, 'hours').format('YYYY-MM-DD HH:mm:ss');
        const response = await sdkClient.getRewardTransactions({
            profileIds: [profileId],
            createdSince: endDate,
            createdUntil: startTime,
        });
        return response?.results;
    } catch (e) {
        return [];
    }
};
